import { render, staticRenderFns } from "./waitingForStorage.vue?vue&type=template&id=0aa854ac&scoped=true"
import script from "./waitingForStorage.vue?vue&type=script&lang=js"
export * from "./waitingForStorage.vue?vue&type=script&lang=js"
import style0 from "./waitingForStorage.vue?vue&type=style&index=0&id=0aa854ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa854ac",
  null
  
)

export default component.exports